(function () {
  'use strict';

  angular
      .module('tfc.retailer.FitConsistency', [])
      .config(config);

  // @ngInject
  function config($stateProvider) {

    $stateProvider
        .state('fitConsistency', {
          abstract : true,
          parent : 'pageWithMenu',
          url : '/fitConsistency',
          data : {
            // TODO: This will change once we figure out the menu organization
            auth : { privilege : 'report.FitConsistency' },
            requireTerms:true
          },
          template : '<ui-view></ui-view>'
        })
        .state('fitConsistency.Consistency', {
          url : '/Consistency?brandKey&hierarchy&department&category&{pageNumber:int}&{pageSize:int}&transaction&region&sortBy&sortOrder',
          params : {
            pageNumber : 1,
            pageSize : 100 // default page size
          },
          templateUrl : 'FitConsistency/FitConsistency.tmpl.html',
          controller : 'FitConsistencyCtrl as vm',
          data:{
            title:'Fit Consistency',
            path:'fitConsistency/Consistency'
          },
          resolve : {
            selectedBrandKey: function(BrandReports, $stateParams){
              return BrandReports.selectedBrandKey($stateParams.brandKey).then(function(selectedBrandKey){
                $stateParams.brandKey = selectedBrandKey;
                return selectedBrandKey;
              });
            },
            filters: function (BrandReports, $stateParams, activityRegion, selectedBrandKey) {
                return activityRegion(function() {
                  return BrandReports.getConsistencyFilters(selectedBrandKey)
                },$stateParams.transaction, $stateParams.region);
            },
            hierarchies : function (BrandReports, $stateParams, filters, selectedBrandKey) {
                var transaction = filters.getSelected();
                var region = transaction && transaction.getSelectedRegion() && transaction.getSelectedRegion().getLabel();
                if(!$stateParams.hierarchy) {
                  $stateParams.hierarchy = "All Categories";
                }
                return BrandReports.findConsistencyHierarchies(selectedBrandKey,region, transaction && transaction.getLabel()).then(function (hierarchies) {
                  return _(hierarchies).filter(function (o) {
                    // Not including Baby, Girls, Boys or UnisexKids
                    return o.department !== "Baby" && o.department !== "Girls" && o.department !== "Boys" && o.department !== "UnisexKids";
                  }).value();
                });
            },
            styleData : function (BrandReports, $stateParams, hierarchies, filters, selectedBrandKey) {
                var transaction = filters.getSelected();
                var region = transaction && transaction.getSelectedRegion() && transaction.getSelectedRegion().getLabel();
                var selectedHierarchy = _.some(hierarchies, {department: $stateParams.department,
                  category: $stateParams.category});
                if(!selectedHierarchy) {
                  $stateParams.hierarchy =  "All Categories";
                  delete $stateParams.department;
                  delete $stateParams.category;
                }
                return BrandReports.findConsistencySizeAdvices(selectedBrandKey, $stateParams.department,
                    $stateParams.category, region, transaction && transaction.getLabel());
            },
            brands : function (BrandReports) {
              return BrandReports.findUserBrandNames();
            },
            aggregationLogDetails: function(BrandReports) {
              return BrandReports.getDashboardAggregationLogDetails('FitConsistency');
            }
          }
        });
  }

})();